const Checkbox = ({
  name,
  title,
  type,
  value,
  label,
  error,
  handleChange,
  placeholder,
  className,
  page,
}) => {
  return (
    <div className="text-start mt-2">
      <label className="form-check form-check-custom form-check-inline form-check-solid mx-2 mb-0">
        <input
          className="form-check-input"
          name={name}
          type="checkbox"
          checked={!!value}
          onChange={(e) => {
            handleChange({ name: name, checked: e.target.checked });
          }}
        />
        <span className=" ps-2 fs-12 form-label">{label}</span>
      </label>

      <div style={page ? { height: "20px" } : {}}>
        <span className="fs-10 text-danger">{error}</span>
      </div>
    </div>
  );
};

export default Checkbox;
